import { render } from "./resources_view.html?vue&type=template&id=bdda3c78&external"
import script from "./resources_view.js?vue&type=script&lang=js&external"
export * from "./resources_view.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__